import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Account, AccountCreate, AccountFilter } from '../data/account';

export function createAccountService(client: AxiosInstance) {
  return createCrudService<Account, AccountCreate, AccountFilter>(client, '/Account', 'accountId');
}

export type AccountService = CrudService<Account, AccountCreate, AccountFilter>;
